/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  shoppingMall.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:33
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { assignParams, axiosAPIUrl, Parameter } from './index'
import {goodsDto} from "@/api/goods";

/* 搜索历史记录 */
export class SearchHistoryDto{
    searchType?:string // 搜索类型
    keyword?:string // 搜索关键字
}

/* 店铺列表字段数据类型 */
export class ShopListDto {
    /* 客户分组编号 */
    groupId?: string;
    /* 客户分组名称 */
    groupName?: string;
    /* 店铺列表 */
    datas?: ShopDataDto[];
}

export class ShopDataDto {
    /* 企业ID */
    merchantCompanyId?: string;
    /* 企业logo */
    merchantCompanyLogo?: string;
    /* 企业名称 */
    merchantCompanyName?: string;
    /* 客户备注名 */
    merchantName?: string;
    /* 客户编码 */
    merchantCode?: string;
    recommendGoodsList?: ShopRecommendGoodsListDto[];
}

export class ShopRecommendGoodsListDto {
    /* 推荐商品名称 */
    recommendGoodsName?: string;
    /* 推荐商品主图 */
    recommendGoodsImage?: string;
    goodsId?: string;
}

/**
 * 获取店铺列表
 * @param parameter
 */
export function getShopList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ShopListDto[]>>({
        url: "/cykjenterprise/shopQuery/getShopList",
        method: "get",
        params: parameter,
    });
}

/**
 * 获取店铺搜索结果列表
 * @param parameter
 */
export function getSearchShopList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ShopDataDto[]>>({
        url: "/cykjenterprise/shopQuery/getSearchShopList",
        method: "get",
        params: parameter,
    });
}

/**
 * 获取搜索框历史记录
 * @param parameter
 */
export function getSearchHistoryList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Array<SearchHistoryDto>>>({
        url: "/cykjbusiness/LQ/getSearchHistoryList",
        method: "post",
        data: parameter,
        extraParams: { showLoading: false }
    });
}

/**
 * 清除搜索框历史记录
 * @param parameter
 */
export function clearSearchHistory(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjbusiness/LM/clearSearchHistory",
        method: "post",
        data: parameter
    });
}

/**
 * 新增搜索框历史记录
 * @param parameter
 */
export function addSearchHistory(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Array<SearchHistoryDto>>>({
        url: "/cykjbusiness/LM/addSearchHistory",
        method: "post",
        data: parameter,
        extraParams: { showLoading: false }
    });
}

/**
 * 获取收藏夹列表
 * @param parameter
 */
export function getFavoriteGoodsList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<goodsDto>>>({
        url: "/cykjenterprise/favorite/getFavoriteGoodsList",
        method: "post",
        data: parameter,
    });
}

/**
 * 判断是否已收藏该商品
 * @param parameter
 */
export function isFavoriteGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{ isFavorite: boolean }>>({
        url: "/cykjenterprise/favorite/isFavoriteGoods",
        method: "get",
        params: parameter,
    });
}

/**
 * 收藏商品
 * @param parameter
 */
export function addFavoriteGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjenterprise/favorite/addFavoriteGoods",
        method: "post",
        data: parameter,
    });
}

/**
 * 取消收藏商品
 * @param parameter
 */
export function deleteFavoriteGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjenterprise/favorite/deleteFavoriteGoods",
        method: "post",
        data: parameter,
    });
}

/**
 * 移出收藏夹
 * @param parameter
 */
export function batchDeleteFavorite(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjenterprise/favorite/batchDeleteFavorite",
        method: "post",
        data: parameter,
    });
}

/**
 * 加入购物车
 * @param parameter
 */
export function addShoppingCart(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjenterprise/shoppingCart/addShoppingCart",
        method: "post",
        data: parameter,
    });
}

/**
 * 移出购物车
 * @param parameter
 */
export function removeShoppingCart(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjenterprise/shoppingCart/batchDeleteShoppingCart",
        method: "post",
        data: parameter,
    });
}

/* 企业商城商品列表数据类型 */
export class ShopGoodsListDto {
    goodsId?: string;
    goodsCode?: string;
    goodsName?: string;
    goodsMainImage?: string;
    goodsPrice?: number | string;
    packageCount?: number;
    isMultiSpec?: boolean;
    isValid?: boolean;
}

/* 企业商城商品详情数据类型 */
export class ShopGoodsInfoDto {
    goodsId?: string;
    goodsName?: string;
    goodsCode?: string;
    /* 商品分类编号 */
    categoryId?: string;
    categoryName?: string;
    /* 品牌编号 */
    brandId?: string;
    brandName?: string;
    /* 视频路径 */
    videoUrl?: string;
    /* 商品主图 */
    goodsMainImage?: string;
    /* 商品描述url */
    descriptionUrl?: string;
    /* 商品描述内容 */
    descriptionContext?: string;
    /* 商品价格 */
    goodsPrice?: number | string;
    /* 商品套餐数量 */
    packageCount?: number;
    /* 是否为多规格 */
    isMultiSpec?: boolean;
    priceShowType ?: number;
    /* 商品图册 */
    goodsImageList?: ShopGoodsImgListDto[];
    /* 商品标签 */
    goodsTagList?: ShopGoodsTagListDto[];
}

export class ShopGoodsImgListDto {
    autoId?: string;
    serialNumber?: number;
    imageName?: string;
    imageUrl?: string;
}

export class ShopGoodsTagListDto {
    tagId?: string;
    tagName?: string;
    tagColor?: string;
}

/**
 * 获取热卖推荐商品列表
 * @param parameter
 */
export function hotSaleList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<ShopGoodsListDto>>>({
        url: "/cykjenterprise/shopGoods/sg0006",
        method: "get",
        params: parameter,
        extraParams: { showLoading: false }
    });
}

/**
 * 获取新品上架商品列表
 * @param parameter
 */
export function newArrivalList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<ShopGoodsListDto>>>({
        url: "/cykjenterprise/shopGoods/sg005",
        method: "get",
        params: parameter,
    });
}

export class ResponseDataTypeDto {
    isOptional?: boolean;
    rejectType?: string;
}

/**
 * 判断商品是否为可订货商品
 * @param parameter
 */
export function isOptionalGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ResponseDataTypeDto>>({
        url: "/cykjenterprise/shopGoods/isOptionalGoods",
        method: "get",
        params: parameter,
    });
}

/**
 * 判断套餐是否为可订货套餐
 * @param parameter
 */
export function isOptionalGoodsPackage(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ResponseDataTypeDto>>({
        url: "/cykjenterprise/shopGoods/isOptionalGoodsPackage001",
        method: "post",
        data: parameter,
    });
}

/* 店铺商品列表页轮播广告 */
export class BannerImgListDto {
    goodsId?: string;
    goodsCode?: string;
    goodsName?: string;
    goodsMainImage?: string;
}

/**
 * 获取轮播广告
 * @param parameter
 */
export function getBannerImgList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<BannerImgListDto[]>>({
        url: "/cykjenterprise/shopGoods/sg003",
        method: "get",
        params: parameter,
        extraParams: { showLoading: false }
    });
}

/**
 * 获取店铺商品列表
 * @param parameter
 */
export function getShopGoodsList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<ShopGoodsListDto>>>({
        url: "/cykjenterprise/shopGoods/sg0004",
        method: "get",
        params: parameter,
    });
}

/**
 * 获取店铺商品详情
 * @param parameter
 */
export function getShopGoodsInfo(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ShopGoodsInfoDto>>({
        url: "/cykjenterprise/shopGoods/getGoodsInfo",
        method: "post",
        data: parameter,
    });
}

/* 商品分类列表数据类型 */
export class ShopGoodsClassListDto {
    companyId?: string;
    hierarchyId?: string;
    categoryLevel?: string;
    categoryName?: string;
    categoryId?: string;
    parentId?: string;
    children?: ShopGoodsClassListDto[];
    /* 是否展开二级分类 */
    isCollapse?: boolean;
}

/**
 * 获取商品分类列表
 * @param parameter
 */
export function getShopGoodsClassLis(parameter: Parameter = {}, showLoading = true) {
    return axiosAPIUrl<Ajax.Response<ShopGoodsClassListDto[]>>({
        url: "/cykjcommodity/shopping/getGoodsCategoryList",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: showLoading
        }
    });
}

/**
 * 分类下筛选商品
 * @param parameter
 */
export function getGoodsListOfCategory(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<ShopGoodsListDto>>>({
        url: "/cykjenterprise/shopGoods/getGoodsListOfCategory",
        method: "post",
        data: parameter,
    });
}

/* 商品品牌列表数据类型 */
export class ShopGoodsBrandListDto {
    brandId?: string;
    brandName?: string;
    companyId?: string;
}

/**
 * 获取商品品牌列表(未分页)
 * @param parameter
 */
export function getShopGoodsBrandList(parameter: Parameter = {}, showLoading = true) {
    return axiosAPIUrl<Ajax.Response<ShopGoodsBrandListDto[]>>({
        url: "/cykjcommodity/shop/getGoodsBrandList",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: showLoading
        }
    });
}

/**
 * 获取商品标签列表(未分页)
 * @param parameter
 */
export function getShopGoodsTagList(parameter: Parameter = {}, showLoading = true) {
    return axiosAPIUrl<Ajax.Response<ShopGoodsTagListDto[]>>({
        url: "/cykjcommodity/GoodsTag/getGoodsTagList",
        method: "post",
        data: parameter,
        extraParams: {
            showLoading: showLoading
        }
    });
}

/**
 * 获判断店铺是否可进入
 * @param parameter
 */
export function isPermitEnterShop(params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjenterprise/shopQuery/isPermitEnterShop",
        method: "post",
        data: {...params, ...assignParams()},
    });
}
